var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.051 14.041"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.511 7.021l.38.409 5.678 6.091.942-.818-5.3-5.682 5.3-5.682-.942-.818L.891 6.612z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}

export default __webpack_public_path__ + "f54edabc4b79d798e9ec1e146dbc5229.svg";
export { SvgChevronLeft as ReactComponent };